import { render, staticRenderFns } from "./face-item.vue?vue&type=template&id=b93fc61a&scoped=true"
import script from "./face-item.vue?vue&type=script&lang=js"
export * from "./face-item.vue?vue&type=script&lang=js"
import style0 from "./face-item.vue?vue&type=style&index=0&id=b93fc61a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93fc61a",
  null
  
)

export default component.exports